<template>
  <Modal @close="closeModal()" class="-mt-10" v-if="isModalOpen">
    <template #message>
      <div class="text-center" v-if="successContributionMessage">
        <div class="">
          <font-awesome-icon
            class="text-green-600 z-20 h-20 w-20 py-2"
            icon="fa-check-circle"
          />
        </div>
        <div class="py-2">
          <div class="px-2 text-black">
            <div class="font-bold text-center text-[13.5px]">
              Contribution Request Submitted Successfully
            </div>
            <div class="mt-4 text-sm text-center font-normal">
              Kindly track processing status from Tickets menu using Case Number
              <div class="block font-bold">
                {{ successContributionMessage }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="exitUploadMessageError">
        <div class="">
          <font-awesome-icon
            class="text-red-600 z-20 h-20 w-20 py-2"
            icon="fa-xmark-circle"
          />
        </div>
        <div class="p-4 text-black">
          <div class="text-[13.5px] font-bold text-center">
            Contribution Schedule upload failed
          </div>
          <div class="mt-4 text-sm text-center font-bold">
            {{ exitUploadMessageError }}
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
// import { defaultLocation } from "@vueuse/core";
import Modal from "./modal.vue";

export default {
  props: {
    isModalOpen: Boolean,
    successContributionMessage: String,
    exitUploadMessageError: String,
  },
  components: { Modal },
  setup(_, { emit }) {
    const closeModal = () => {
      emit("close");
    };

    return { closeModal };
  },
};
</script>
